import { Link } from 'react-router-dom';
import { ProductListing } from '../../../components/ProductListing/ProductListing';
import { useTranslation } from '../../../i18n/i18n';
import { Res, useCms } from '../../../state/api';
import { ErrorMessage } from '../../ErrorMessage/ErrorMessage';
import { Loader } from '../../Loader/Loader';
import { renderTemplate } from '../../utils';
import './CmsProductList.css';

type CmsProductListProps = {
	title: string;
	endpoint: string;
	moreUrl: string;
};

export const CmsProductList = ({ title, moreUrl, endpoint }: CmsProductListProps): JSX.Element => {
	const t = useTranslation().sort;
	const tGeneric = useTranslation().generic;
	const { data, error } = useCms(Res.cmsEndpoint, { endpoint });

	if (error) return <ErrorMessage />;
	if (!data) return <Loader size="line" />;
	if (data?.products && data?.products?.length === 0) return <ErrorMessage />;

	return (
		<div className="cms-product-listing">
			<h2>
				{title} <small>({renderTemplate(t.items, { total: data.total })})</small>
			</h2>
			<ProductListing products={data.products} />
			<div className="text-center view-more-button">
				<Link className="button" to={moreUrl}>
					{tGeneric.showMore}
				</Link>
			</div>
		</div>
	);
};
